import React, { useState, useEffect } from "react";
import OTPModal from "./OTPModal";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SuccessMessages from "../../../constants/SucessMessages.json";
import Table from "../../Common/Table";
import TableFields from "../../../constants/AssetsIssuance/TableFields.json";
import * as AssetsIssuanceActions from "../../../store/actions/AssetsIssuance";
import * as UserActions from "../../../store/actions/User";

const convertAsArray = (obj) => {
  var arr = [];
  Object.keys(obj).forEach((key) => {
    arr.push({
      ...obj[key],
      name: key,
    });
  });
  return arr;
};

const OTPVerification = (props) => {
  const {
    issuingAssets,
    next,
    completed,
    disabled,
    driverDetails,
    sendOtp,
    setStatus,
  } = props;
  const [confirmPerson, setConfirmPerson] = useState(completed);
  const [inputDisabled, setInputDisabled] = useState(true);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [error, setError] = useState("");
  const [localLoader, setLocalLoader] = useState(false);

  useEffect(() => {
    setInputDisabled(completed || disabled);
  }, [completed, disabled]);

  const handleInputChange = (event) => {
    const value = event.target.checked;
    setConfirmPerson(value);
  };
  const handleSendOtp = (e) => {
    e.preventDefault();
    if (inputDisabled) {
      return;
    }
    if (confirmPerson) {
      setError("");
      setLocalLoader(true);
      const payload = {
        assets_data: issuingAssets,
        phone_no: driverDetails.phone_number,
      };
      sendOtp(payload).then((res) => {
        if (res) {
          setStatus({
            type: "success",
            message: SuccessMessages.OTP_SEND_SUCCESS,
          });
          setShowOtpModal(true);
        } else {
          console.log("something went wrong");
        }
        setLocalLoader(false);
      });
    } else {
      setError("You need to verify above or cancel");
    }
  };
  const getFieldValue = (item, key) => {
    return item[key];
  };

  return (
    <div className={"flex flex-col h-full w-full justify-between text-center"}>
      <div className={"mb-20"}>
        <Table
          list={convertAsArray(issuingAssets)}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
      </div>
      <label className={"mb-20"}>
        I confirm the person picking up the assets and the person in PAN is the
        same.
        <input
          name="isGoing"
          type="checkbox"
          checked={confirmPerson}
          onChange={handleInputChange}
          disabled={inputDisabled}
        />
      </label>

      {error && (
        <>
          <div className="error-state otp-error mb-10">{"*" + error}</div>
        </>
      )}
      <Button
        loading={localLoader}
        type="submit"
        onClick={handleSendOtp}
        disabled={inputDisabled}
        className={"mb-20"}
      >
        Send OTP
      </Button>
      {showOtpModal && (
        <OTPModal
          handleReject={() => {
            setShowOtpModal(false);
          }}
          next={next}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { AssetsIssuance } = state;
  return {
    driverDetails: AssetsIssuance.driverDetails,
    issuingAssets: AssetsIssuance.issuingAssets.assets_data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendOtp: bindActionCreators(AssetsIssuanceActions.sendOtp, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OTPVerification);
